/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfVital } from '../../models/data-page-of-vital';

export interface VitalList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  mrn?: string | null;
  pageNumber?: number;
  sortbydirection?: string | null;
  Toggle?: string | null;
}

export function vitalList(http: HttpClient, rootUrl: string, params?: VitalList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfVital>> {
  const rb = new RequestBuilder(rootUrl, vitalList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('mrn', params.mrn, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
    rb.query('Toggle', params.Toggle, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfVital>;
    })
  );
}

vitalList.PATH = '/vitals/list';
